import React from 'react';
import '../../assets/css/pagebanner.css';

const PageBanner = ({
    backgroundImage,
    height = "70vh",
    alt = "Banner image",
    className = "",
    title,
    subtitle,
    children,
    textAlign = "center",
    overlay = false
}) => {
    return (
        <div className={`page-banner-container ${className}`}>
            <img
                src={backgroundImage}
                alt={alt}
                className="page-banner-image"
                style={{ height: height }}
            />
            {(title || subtitle || children) && (
                <div className={`banner-content-overlay ${textAlign}`}>
                    {overlay && <div className="image-overlay" />}
                    <div className="banner-content-wrapper">
                        {title && <h1 className="banner-title">{title}</h1>}
                        {subtitle && <p className="banner-subtitle">{subtitle}</p>}
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageBanner;